<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>供应商账款总览</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="供应商名称：">
              <div class="approval" @click="suIdClick(params.purchaseAccountBaseVo.suId)">
                {{
                params.purchaseAccountBaseVo.suName
                }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款类型：">
              {{
              params.purchaseAccountBaseVo.tradeType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="账户余额：">
              {{
              params.purchaseAccountBaseVo.accountBalance |priceFilterNum
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="应付账款总额：">
              {{
              params.purchaseAccountBaseVo.accountsPayable |priceFilterNum
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已到期账款总额：">
              {{
              params.purchaseAccountBaseVo.accountsDue |priceFilterNum
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="待审核付款总额：">
              {{
              params.purchaseAccountBaseVo.toAuditMoney |priceFilterNum
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="履行中合同：">
              {{
              params.purchaseAccountBaseVo.count
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>应付款合同</span>
      </div>
      <el-table
        style="margin-top:20px"
        border
        ref="tableRef"
        :data="params.purchaseContractBaseAccountsVoList"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column show-overflow-tooltip prop="contractFrom" label="合同类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop label="合同编号">
          <template slot-scope="scope">
            <div
              @click="pcbNumber(scope.row)"
              class="approval line-limit-length"
            >{{ scope.row.pcbNumber }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="suName" label="供应商名称" min-width="100px">
          <template slot-scope="scope">
            <div
              @click="suNameClick(scope.row)"
              class="approval line-limit-length"
            >{{ scope.row.suName }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="payType" label="付款类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="purchaseTotal" label="合同金额">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.purchaseTotal |priceFilterNum}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="accountPayable" label="应付账款">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.accountPayable |priceFilterNum}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="accountDue" label="已到期账款" width="100px">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.accountDue |priceFilterNum}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="toAuditMoney" label="待审核付款" width="100px">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.toAuditMoney |priceFilterNum}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="amountPayment" label="本次付款金额" width="160px">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.amountPayment"
              :min="0"
              :max="scope.row.accountPayable - scope.row.toAuditMoney"
              :precision="2"
              :placeholder="
                '0 ~ ' + (scope.row.accountPayable - scope.row.toAuditMoney)
              "
              :controls="false"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="deliverStates" label="发货状态">
          <template slot-scope="scope">
            <span>{{ scope.row.deliverStates }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="invoiceStates" label="收票状态"></el-table-column>
        <el-table-column show-overflow-tooltip prop="isApplication" label="是否存在退货申请" width="140px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="staffCnName" label="当前负责人" width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip width="150px" prop="createDate" label="签订时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate | dateFilter }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="item-box-content">
      <div class="title-font-style">
        <span>付款信息</span>
      </div>
      <el-form label-width="70px" style="padding:0 0 0 30px;">
        <el-row>
          <el-col :span="22">
            <el-form-item label="付款类型：" style="margin-bottom:20px;margin-top:20px;">
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-radio-group v-model="status">
                    <el-radio :label="1">银行转账</el-radio>
                    <el-radio :label="2">承兑汇票</el-radio>
                    <el-radio :label="3">账户余额</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注：">
              <el-input v-model="params.mark" :rows="4" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="background:#F3F7FF;height:48px;line-height:48px;margin:0 10px;padding:0 10px;">
        申请付款总额：
        <span style="color:#D35E5E;">{{ count | toFixed}}</span>
      </div>
    </div>
    <div class="item-box-content" v-show="status === 1 || status === 2">
      <div class="title-font-style">
        <span>银行转账账户</span>
      </div>
      <el-form label-width="70px" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行户名：">{{ params.purchaseAccountBaseVo.suName }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行账号：">
              <el-select v-model="params.bankCode" @change="changeBank">
                <el-option
                  v-for="(item, index) in contractScreenCondition"
                  :key="index"
                  :label="item.bankCode"
                  :value="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">
              <el-input :disabled="true" v-model="params.bankOpencount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行行号：">
              <el-input :disabled="true" v-model="params.bankNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <el-button @click="onAddAccount" type="primary" plain>添加账户</el-button>
        </div>
      </el-form>
    </div>
    <div>
      <el-button @click="onPaymentApplication" type="primary">申请付款</el-button>
    </div>
    <!------------ 添加账户 ------------>
    <add-bank-account-dialog @addAccountDialog="addAccountDialog" ref="addBankAccountDialogRefs"></add-bank-account-dialog>
    <!-------------- 申请付款二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataStatePrice="onUpdataStatePrice"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import addBankAccountDialog from '@/components/AddAccount/addAccountDialog'
import {
  querySupplierAccount,
  queryBySuId,
  addPurchaseAccount,
  querySupplierAccountByScpId
} from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'
import openOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'add-bank-account-dialog': addBankAccountDialog,
    'open-or-close': openOrClose
  },
  data () {
    return {
      list: [],
      paymentTotal: 0, // 金额总数
      count: 0, // 列表金额总数
      params: {
        purchaseAccountBaseVo: {
          tradeNumber: '',
          tradeType: '',
          count: 0,
          suName: '',
          accountBalance: 0,
          accountsPayable: 0,
          accountsDue: 0,
          toAuditMoney: 0
        },
        purchaseContractBaseAccountsVoList: []
      },
      contractScreenCondition: [],
      loadingTable: false,
      checkedAcceptanceBill: false,
      checkedBrand: false,
      checkedAccount: false,
      type: '',
      status: 1,
      title: '',
      content: ''
    }
  },
  watch: {
    // 金额计算
    params: {
      handler (newVal) {
        this.count = 0
        if (newVal.purchaseContractBaseAccountsVoList !== null) {
          newVal.purchaseContractBaseAccountsVoList.forEach((element) => {
            if (element.amountPayment === undefined) {
              element.amountPayment = 0
            }
            this.count += element.amountPayment
          })
          this.count.toFixed(2)
        }
      },
      deep: true
    },

    checkedBrand: {
      handler (newVal) {
        if (newVal === false) {
          this.params.bankTransfer = 0
          this.bankPrice()
        }
      }
    },
    checkedAcceptanceBill: {
      handler (newVal) {
        if (newVal === false) {
          this.params.moneyOrder = 0
          this.bankPrice()
        }
      }
    },
    checkedAccount: {
      handler (newVal) {
        if (newVal === false) {
          this.params.accountBalance = 0
          this.bankPrice()
        }
      }
    }
  },
  mounted () {
    if (this.$route.query.type === 'again') {
      querySupplierAccountByScpId(
        this.$route.query.scpId,
        this.$route.query.sabId
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.params = res.data.obj
            if (this.params.salesExist === 1) {
              this.onInitial()
            }
            this.bankList()
            if (this.params.accountBalance !== null) {
              this.status = 3
            } else if (this.params.bankTransfer !== null) {
              this.status = 1
            } else if (this.params.moneyOrder !== null) {
              this.status = 2
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      querySupplierAccount(this.$route.query.sabId)
        .then((res) => {
          if (res.data.code === 200) {
            this.params = res.data.obj

            this.bankList()
            if (this.params.salesExist === 1) {
              this.onInitial()
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  methods: {
    suNameClick (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    suIdClick (suId) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: suId }
      })
    },
    pcbNumber (row) {
      // const state = this.state[row.contractState - 1]
      this.$router.push({
        name: 'contractDetails',
        query: { pcbId: row.pcbId }
      })
    },
    // 请求银行账户
    bankList () {
      queryBySuId(this.params.purchaseAccountBaseVo.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractScreenCondition = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 银行账户change
    changeBank () {
      this.contractScreenCondition.forEach((element) => {
        if (element.bankCode === this.params.bankCode) {
          this.params.bankNumber = element.bankOpenCode
          this.params.bankOpencount = element.bankOpencount
        }
      })
    },
    addAccountDialog () {
      this.bankList()
    },
    onInitial () {
      this.title = '申请付款提醒'
      this.content =
        '所选合同产品中存在处理中的售后退货申请！请再次确认是否提交付款审核，提交后不可撤销，待审核完毕后将扣除余额'
      this.$refs.OpenOrCloseRefs.onInitial('begin')
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 添加账户
    onAddAccount () {
      const params = {
        suName: this.params.purchaseAccountBaseVo.suName,
        suId: this.params.purchaseAccountBaseVo.suId
      }
      this.$refs.addBankAccountDialogRefs.onInitial(params)
    },
    // 前往充值
    onUpdataStatePrice () {
      // this.$message('充值')
      const { suId, suName } = this.params.purchaseAccountBaseVo
      this.$router.push({
        name: 'supplierRechargeOn',
        query: {
          id: suId,
          name: suName
        }
      })
    },
    // 申请付款
    onPaymentApplication () {
      if (this.count === 0) {
        this.$message.error('申请付款失败，付款金额不可为0！')
      } else if (
        this.status === 3 &&
        this.count > this.params.purchaseAccountBaseVo.accountBalance
      ) {
        this.title = '余额不足'
        this.content =
          '当前供应商账户余额不足以付款，请前往供应商详情页充值或调整付款项目及金额'
        this.$refs.OpenOrCloseRefs.onInitial('end', 'max')
      } else if (
        this.status === 3 &&
        this.count <= this.params.purchaseAccountBaseVo.accountBalance
      ) {
        this.title = '付款申请'
        this.content =
          '本次付款申请金额为' +
          this.count +
          '元，请再次确认是否提交付款审核，提交后不可撤销，待审核完毕后将扣除余额'
        this.$refs.OpenOrCloseRefs.onInitial('end')
      } else {
        let isTrue = false
        if (this.params.bankCode === null) {
          this.$message.error('请选择银行信息')
          isTrue = true
        }

        if (!isTrue) {
          this.title = '付款申请'
          this.content =
            '本次付款申请金额为' +
            this.count +
            '元，请再次确认是否提交付款审核，提交后不可撤销，待审核完毕后交由财务打款'
          this.$refs.OpenOrCloseRefs.onInitial('end')
        }
      }
    },
    onUpdataState (val) {
      const paramData = JSON.parse(JSON.stringify(this.params))
      paramData.paymentTotal = this.count
      if (this.status === 1) {
        paramData.bankTransfer = this.count
        paramData.moneyOrder = null
        paramData.accountBalance = null
        paramData.suBank = this.params.purchaseAccountBaseVo.suName
      } else if (this.status === 2) {
        paramData.bankTransfer = null
        paramData.moneyOrder = this.count
        paramData.accountBalance = null
        paramData.suBank = this.params.purchaseAccountBaseVo.suName
      } else if (this.status === 3) {
        paramData.bankTransfer = null
        paramData.moneyOrder = null
        paramData.accountBalance = this.count
        paramData.suBank = null
        paramData.bankCode = null
        paramData.bankOpencount = null
        paramData.bankNumber = null
      }

      addPurchaseAccount(paramData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('申请付款成功')
            this.$router.push({ name: 'waitGatheringSupplierList' })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
